export const getHomePath = () => {
  return "/";
};

export const getCompaniesPath = () => {
  return "/companies";
};
